enum ComponentSection {
    GENERAL = 'general',
    ELECTRICAL = 'electrical',
    PERFORMANCE = 'performance',
    COMMUNICATION = 'communication',
    STANDARDS = 'standards',
    MECHANICAL = 'mechanical',
    ENVIRONMENTAL = 'environmental',
    IMAGES = 'images',
    FILES = 'files',
    QUESTIONS = 'questions',
    PROJECTS = 'projects',
    COMPATIBLE_WITH = 'compatibleWith',
}

type ComponentSectionsProgress = Record<ComponentSection, number>;

const ComponentSections = [
    ComponentSection.GENERAL,
    ComponentSection.ELECTRICAL,
    ComponentSection.PERFORMANCE,
    ComponentSection.COMMUNICATION,
    ComponentSection.STANDARDS,
    ComponentSection.MECHANICAL,
    ComponentSection.ENVIRONMENTAL,
    ComponentSection.IMAGES,
    ComponentSection.FILES,
    ComponentSection.QUESTIONS,
    ComponentSection.PROJECTS,
    ComponentSection.COMPATIBLE_WITH,
] as const;

const DefaultComponentSections: ComponentSection[] = [
    ComponentSection.GENERAL,
    ComponentSection.ELECTRICAL,
    ComponentSection.PERFORMANCE,
    ComponentSection.COMMUNICATION,
    ComponentSection.STANDARDS,
    ComponentSection.MECHANICAL,
    ComponentSection.ENVIRONMENTAL,
    ComponentSection.IMAGES,
    ComponentSection.FILES,
    ComponentSection.QUESTIONS,
];

export { ComponentSection, ComponentSections, DefaultComponentSections };
export type { ComponentSectionsProgress };
